import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../css/EditNotification.css';
import api from '../utils/axiosConfig';

const EditNotificationAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    userCode: '',
    sessionName: '',
    scheduledAt: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await api.get(`/api/notifications/${id}`);
        const notification = response.data.notification;
        setFormData({
          userCode: notification.userCode,
          sessionName: notification.sessionName,
          scheduledAt: convertUtcToLocalDateTimeInput(notification.scheduledAt)
        });
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.error || 'Fehler beim Laden der Benachrichtigung');
        setLoading(false);
      }
    };

    fetchNotification();
  }, [id]);

  function convertUtcToLocalDateTimeInput(utcString) {
    const date = new Date(utcString);
    const offset = date.getTimezoneOffset(); // in minutes
    const localDate = new Date(date.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:mm'
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    try {
      const response = await api.put(`/api/notifications/${id}`, formData);
      if (response.data.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate(`/dashboard/notifications`);
        }, 1500);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Aktualisieren der Benachrichtigung');
      console.error('Error updating notification:', err);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="edit-notification-container">
      <h1>Zeitplan bearbeiten</h1>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
      
      {success && (
        <div className="success-message">
          Zeitplan erfolgreich aktualisiert!
        </div>
      )}

      <form onSubmit={handleSubmit} className="edit-notification-form">
        <div className="form-group">
          <label htmlFor="userCode">
            Teilnehmer Code
          </label>
          <input
            type="text"
            id="userCode"
            name="userCode"
            value={formData.userCode}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="sessionName">
            Session Name
          </label>
          <input
            type="text"
            id="sessionName"
            name="sessionName"
            value={formData.sessionName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="scheduledAt">
            Datum & Uhrzeit
          </label>
          <input
            type="datetime-local"
            id="scheduledAt"
            name="scheduledAt"
            // value={formData.scheduledAt}
            value={formData.scheduledAt || ''}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="cancel-button"
            onClick={() => navigate(-1)}
          >
            Abbrechen
          </button>
          <button
            type="submit"
            className="submit-button"
          >
            Änderung speichern
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditNotificationAdmin;